<template>
  <div class="weeklySpecial stairs">
    <!--头部-->
    <div class="weekly-title">
      <div class="hot-content">
        <div class="weekly-title-logo">套餐专区</div>
        <div class="weekly-time">
          <div class="weekly-more">
            <router-link to="/ComPackageZone">
              查看更多
              <Icon type="ios-arrow-forward" />
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!--头部-->
    <!--内容-->
    <!--特价分类-->
    <div class="weekly-classify">
      <ul class="weekly-classify-ul" style="margin-top: -40px;">
        <!--  <li v-for="(item, index) in weekly.link" :key="index">{{item}}</li>-->
        <!-- <li @click="westernGoods" class="active">西药</li> -->
        <!-- <li @click="chineseGoods">中药</li>-->
      </ul>
    </div>
    <!--特价分类-->
    <div class="composition" v-for="(item, index) in list" :key="index" v-show="index==0">
      <div class="weekly-other-item">
        <div class="composition-item" v-for="(j, inx) in item.list" :key="inx - 10">
          <div class="composition-item-img">
            <img style="width: 230px;height: 230px;max-width: 230px;cursor: pointer;" @click="goIndexDetail(item)"
              :src="j.goods_img || '/static/img/goodsList/goods_default_img.jpg'" alt="">
          </div>
          <div class="composition-item-content">
            <p class="content-title" :title="j.goods_name">{{ j.goods_name }}</p>
            <p class="content-spec" :title="j.specification">{{ j.specification }}</p>
            <p class="content-spec" :title="j.manufacturer_name">{{ j.manufacturer_name }}</p>
            <p class="price">￥ {{ j.selling_price }}<span class="spec">x {{ j.num }}/{{ j.unit }}</span></p>
          </div>
        </div>
      </div>

      <div class="weekly-other-bottom">
        <div class="title" :title="item.package_name">
          {{ item.package_name }}
        </div>
        <div style="display: flex;align-items: baseline;">
          <div class="zuhe">原价：
            <span class="zuhe-fuhao">
              <span style="margin-right:20px;color: #B6B6B6;text-decoration: line-through;">￥ {{item.original}}</span>
            </span>
          </div>
          <div class="zuhe">组合套餐价：
            <span class="zuhe-fuhao">￥
              <span class="zuhe-price">{{ item.package_price }}</span>
            </span>

        </div>
          <div class="add-cart" @click="addToCart(item.package_id)">加入购物车</div>
        </div>
      </div>
    </div>
    <!--内容-->
  </div>
</template>


<script>
import { mapActions } from "vuex";
export default {
  name: '',
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.$http.get('index/getPackagelist').then(res => {
      console.log('res.data', res.data);
      this.list = res.data || []
    })
  },
  methods: {
    ...mapActions(["goodAddPackageCart"]),
    goIndexDetail(item) {
      // TODO 首页详情跳转
      console.log(222, item);
      // this.$router.push({
      //   path: item.ad_url
      //   /* query: { id: item.goods_id }*/
      // });
      // 跳转新页面
      window.open(this.$router.resolve({ path: `/goodsDetail?id=${item.package_goods_id}` }).href, "_blank");
    },
    //加入购物车
    addToCart(package_id) {
      let _this = this;
      let id = {
        package_id: package_id,
      };
      this.goodAddPackageCart(id)
        .then((res) => {
          console.log("...........11",);
          _this.$Message.success(res.msg);
        })
        .catch((err) => {
          console.log("...........22",);
          _this.$Message.error(err);
        });
    }
  },

}
</script>

<style lang="less" scoped>
.weeklySpecial {
  margin-top: 60px;

  .hot-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .weekly-title {
    .weekly-title-logo {
      font-size: 40px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 56px;
      width: 188px;
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #040707;
      margin-left: 15px;
      color: #333333;
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #358dd1;
      }
    }
  }

  .weekly-classify {
    .weekly-classify-ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 28px 0;
    }

    .weekly-classify-ul li {
      padding-left: 20px;
      cursor: pointer;
    }

    .weekly-classify-ul li:hover {
      color: #358dd1;
    }

    .weekly-classify-ul li.active {
      color: #358dd1;
    }
  }

  .composition {
    display: -webkit-box;
    display: -ms-flexbox;
    border-radius: 10px;
    border: 1px solid #008CD9;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    .weekly-other-item {
      width: 99%;
      overflow: auto;
      border-bottom: 1px solid #F0F0F0;
      // background: #fff;
      padding: 10px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      /* 设置滚动条样式 */
      scrollbar-width: 5px;
      scrollbar-color: #008CD9 transparent;

      /* Webkit 浏览器 (Chrome, Safari) 的滚动条样式 */
      &::-webkit-scrollbar {
        height: 5px;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #008CD9;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }

      // text-align: center;
      .composition-item {
        margin-right: 10px;
      }

      .composition-item-img {
        width: 240px;
        height: 240px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .composition-item-content {
        padding: 10px;
        width: 240px;

        text-align: left;

        .content-title {
          width: 100%;
          font-size: 16px;
          font-family: PingFangHK, PingFangHK;
          font-weight: 500;
          color: #333333;
          height: 22px;
          line-height: 22px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .content-spec {
          margin-top: 5px;
          height: 17px;
          font-size: 12px;
          font-family: PingFangHK, PingFangHK;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .price {
          margin-top: 10px;
          height: 28px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #FF0012;
          line-height: 20px;
          text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);

          .spec {

            margin-left: 5px;
            height: 17px;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            text-shadow: 0px 2px 6px rgba(220, 220, 220, 0.3);
          }
        }
      }
    }

    .weekly-other-bottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;

      .title {
        max-width: 750px;
        height: 22px;
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .zuhe {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;

        .zuhe-fuhao {
          font-size: 14px;
          color: #FF0000;

          .zuhe-price {
            font-size: 20px;
            color: #FF0000;
          }
        }
      }

      .add-cart {
        margin-left: 22px;
        width: 90px;
        height: 28px;
        background: #FF0000;
        box-shadow: 0px 2px 4px 0px rgba(176, 2, 0, 0.2);
        border-radius: 14px;
        cursor: pointer;
        font-size: 12px;
        font-family: PingFangHK, PingFangHK;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 28px;
        text-align: center;
      }
    }
  }




}
</style>



// WEBPACK FOOTER //
// src/components/components/SetMealArea.vue